export default __webpack_public_path__ + "static/media/swim.7cc2a1a7.png";